import rmskincareAPI from '../utils/rmskincareAPI'

const paymentApi = {
  // getRoleMenu: async () => {
  //   let result = await rmskincareAPI.get('management/menu/list')
  //   return result.data.data
  // },

  // initial role with id=0
  searchRoleByRoleId: async (roleId) => {
    let result = await rmskincareAPI.get(
      `/management/role/find?roleId=${roleId}`
    )
    return result.data.data
  },
  getRoleList: async () => {
    let result = await rmskincareAPI.get(`/management/role/list`)
    return result.data.data
  },
  deleteRole: async (roleId) => {
    let result = await rmskincareAPI.delete(`/management/role/del?roleId=${roleId}`)
    return result.data.data
  },
  createRole: async (requestBody) => {
    let result = await rmskincareAPI.post('/management/role/add', requestBody)
    return result.data.data
  },
  editRole: async (requestBody) => {
    const result = await rmskincareAPI.post(
      `/management/role/edit`,
      requestBody
    )
    return result.data.data
  },
  // softDeletePayment: async (requestBody, roleId) => {
  //   const result = await rmskincareAPI.post(
  //     `management/finance/payment/method/save`,
  //     requestBody
  //   )
  //   return result.data.data
  // },
}

export default paymentApi
